import { Para, Stack } from 'ui-components';
import ControlledSelectInput from './ControlledSelectInput';
import { EarStyle, Neckline } from 'drycut-graphql';
import ControlledNumberField from './ControlledNumberField';

export default function ShortHairOptions(): JSX.Element {
  const EarStyles: Record<EarStyle, string> = {
    [EarStyle.NotDefined]: '—',
    [EarStyle.Uncovered]: 'frei',
    [EarStyle.Covered]: 'bedeckt',
  };

  const NeckLines: Record<Neckline, string> = {
    [Neckline.NotDefined]: '—',
    [Neckline.Straight]: 'gerade',
    [Neckline.Tapered]: 'auslaufend',
  };

  const necklineOptions = Object.keys(NeckLines).map((key) => ({
    value: key,
    label: NeckLines[key as Neckline],
  }));

  const earsOptions = Object.keys(EarStyles).map((key) => ({
    value: key,
    label: EarStyles[key as EarStyle],
  }));

  return (
    <Stack gap={2} className="w-full">
      <Stack direction="row" className="w-full flex justify-between">
        <Para as="label" htmlFor="lengthSides">
          Länge Seite
        </Para>

        <div>
          <ControlledNumberField name="lengthSides" />
        </div>
      </Stack>

      <Stack direction="row" className="w-full flex justify-between">
        <Para as="label" htmlFor="lengthTop">
          Länge oben
        </Para>

        <div>
          <ControlledNumberField name="lengthTop" />
        </div>
      </Stack>

      <Stack direction="row" className="w-full flex justify-between">
        <Para as="label" htmlFor="ears">
          Ohren
        </Para>

        <ControlledSelectInput name="ears" options={earsOptions} />
      </Stack>

      <Stack direction="row" className="w-full flex justify-between">
        <Para>Nacken</Para>

        <ControlledSelectInput name="neckline" options={necklineOptions} />
      </Stack>
    </Stack>
  );
}
